import { render, staticRenderFns } from "./activityFacultyProfile.html?vue&type=template&id=1c906d08&scoped=true&external"
import script from "./activityFacultyProfile.vue?vue&type=script&lang=js"
export * from "./activityFacultyProfile.vue?vue&type=script&lang=js"
import style0 from "./activityFacultyProfile.css?vue&type=style&index=0&id=1c906d08&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c906d08",
  null
  
)

export default component.exports